module.exports = __webpack_public_path__ + "img/morning.e75dcc9a.jpg";